import React from 'react'
import './Footer.css';
import CircleIcon from '@mui/icons-material/Circle';

function Footer() {
  const email = 'darshkumar.jasani@gmail.com';
  return (
    <>
        <div className='footerBody'>
            <div className='footerStart'>&copy; Copyright 2024. Darshkumar Jasani</div>
        </div>
    </>
  )
}

export default Footer